import { useApiClient } from "@/hooks/useApiClient";
import useSWR from "swr";

export interface DmUsageResponse {
  id: number;
  memo: string;
  quantity: number;
  price: number;
  amount: number;
  createdAt: string;
}

/**
 * ログインユーザーの指定年月のDM利用を取得する。
 * @param year - 年。未指定の場合は取得しない
 * @param month - 月。未指定の場合は取得しない
 * @returns DM利用の一覧。未取得・取得中は undefined
 */
export const DmUsagesAPI = (
  year: number | undefined,
  month: number | undefined
): DmUsageResponse[] | undefined => {
  const { apiClient } = useApiClient();
  const params = {
    year,
    month,
  };
  const url = "/credit/dm-usages";

  const fetcher = async (): Promise<DmUsageResponse[]> => {
    return (
      await apiClient.get<DmUsageResponse[]>(url, {
        params,
      })
    ).data;
  };
  const { data: dmUsages } = useSWR(
    year !== undefined && month !== undefined ? { url, params } : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );

  return dmUsages;
};
